import { render, staticRenderFns } from "./OfferMaterialTable.vue?vue&type=template&id=19986424"
import script from "./OfferMaterialTable.vue?vue&type=script&lang=js"
export * from "./OfferMaterialTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports